import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
        onExportExcel={props.onExportExcel}
        onExportPdf={props.onExportPdf}
        onPrint={props.onPrint}
        onChange={props.onChange}
        pagination={props.pagination}
        rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                // {
                //     title: 'Chofer',
                //     dataIndex: 'nombreChofer',
                //     key: 'nombreChofer',
                //     sorter: true
                // },
                {
                    title: 'Placa',
                    dataIndex: 'placa',
                    key: 'placa',
                    sorter: true
                },
                {
                    title: 'Color',
                    dataIndex: 'color',
                    key: 'color',
                    sorter: true
                },
                {
                    title: 'Marca',
                    dataIndex: 'marca',
                    key: 'marca',
                    sorter: true
                },
                {
                    title: 'Modelo',
                    dataIndex: 'modelo',
                    key: 'modelo',
                    sorter: true
                },
                {
                    title: 'Empresa de Transporte',
                    dataIndex: 'nombreTransporte',
                    key: 'nombreTransporte',
                    sorter: true
                },  
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}